// extracted by mini-css-extract-plugin
export default {"wrapper":"UnderMaintenance_wrapper__Hh5vF","container":"UnderMaintenance_container__Upp5C","image":"UnderMaintenance_image__XGIwo"};